<template>
	<div class="product-img-uploader">
		<p class="product-img-uploader__noti" v-if="!imgSrc">
			※ 등록 가능 포맷: JPG, JPEG, PNG
			<br />
			※ 이미지 사이즈: 500 X 500
			<br />
			※ 용량: 300KB 이하
		</p>
		<label class="product-img-uploader__upload-btn btn">
			{{ imgSrc ? '사진 변경' : '사진 등록' }}
			<input
				class="product-img-uploader__upload-btn__input"
				type="file"
				accept="image/jpeg, image/png"
				@change="imageChange"
			/>
		</label>
		<div class="product-img-uploader__img-box" v-if="imgSrc">
			<img class="product-img-uploader__img" :src="imgSrc" />
			<button
				class="btn-originalimage"
				type="button"
				@click="popupImages"
			></button>
			<div class="product-img-uploader__img-info">
				<p class="product-img-uploader__img-info__text">
					원본 파일명 {{ imgFileName }}
				</p>
				<p class="product-img-uploader__img-info__text">
					파일 크기: {{ imgFileSize }}byte
				</p>
				<template v-if="hasSaveFile">
					<p class="product-img-uploader__img-info__text">
						업로드된 파일명: {{ fileSaveName }}
					</p>
					<p class="product-img-uploader__img-info__text">
						업로드된 경로: {{ fileDir }}
					</p>
				</template>
				<p class="product-img-uploader__img-info__text">
					파일 타입: {{ imgFileType }}
				</p>
			</div>
		</div>
	</div>
</template>

<script>
	import { mapState } from 'vuex';
	import util from '@/util.js';

	export default {
		name: 'ProductImgUploader',
		computed: {
			...mapState('ProductController', [
				'hasSaveFile',
				'imgSrc',
				'imgFileName',
				'imgFileSize',
				'imgFileType',
				'fileSaveName',
				'fileDir',
			]),
		},
		methods: {
			popupImages() {
				util.popupImages([this.imgSrc]);
			},
			setImgData(imgSrc, imgFileName, imgFileSize, imgFileType) {
				this.$store.commit('ProductController/setImgData', {
					imgSrc,
					imgFileName,
					imgFileSize,
					imgFileType,
				});
			},
			setImgDto(fileDir, type, name) {
				this.$store.commit('ProductController/setImgDto', {
					data: fileDir,
					extension: type,
					fileName: name,
					uploadFlag: true,
					target: 'product',
				});
			},
			imageChange(e) {
				try {
					this.$store.commit('toggleSpinner', true);
					const file = e.target.files[0];
					e.target.value = null;
					if (
						file.type !== 'image/jpeg' &&
						file.type !== 'image/png'
					) {
						throw '파일 포맷은 Jpg, jpeg, png 만 가능합니다.';
					}
					const reader = new FileReader();
					reader.onloadend = readerRes => {
						if (readerRes.total > 300000) {
							alert('300KB이하의 사진을 등록하세요');
							return;
						}
						const fileDir = readerRes.target.result;
						const imgObj = new Image();
						imgObj.onload = () => {
							const width = imgObj.width;
							const height = imgObj.height;
							if (!(width === 500 && height === 500)) {
								alert('500x500 이미지만 등록 가능합니다.');
								return;
							}
							const fileType = (name => {
								const splitName = name.split('.');
								return splitName[splitName.length - 1];
							})(file.name);
							this.setImgData(
								fileDir,
								file.name,
								file.size,
								fileType
							);
							this.setImgDto(fileDir, fileType, file.name);
						};
						imgObj.onerror = err => {
							console.error(err);
							alert(
								'이미지를 불러오는데 오류가 발생했습니다. 개발팀에 문의하세요.'
							);
						};
						imgObj.src = fileDir;
					};
					reader.onerror = err => {
						console.error(err);
						alert(
							'이미지를 불러오는데 오류가 발생했습니다. 개발팀에 문의하세요.'
						);
					};
					if (file) reader.readAsDataURL(file);
				} catch (err) {
					alert(err);
					console.error(err);
				} finally {
					this.$store.commit('toggleSpinner', false);
				}
			},
		},
	};
</script>

<style lang="scss" scoped>
	.product-img-uploader {
		.product-img-uploader__noti {
			display: block;
			line-height: 18px;
			color: $red;
			font-size: 0.875rem;
			font-weight: normal;
		}

		.product-img-uploader__upload-btn {
			display: inline-block;
			margin-top: 14px;
		}

		.product-img-uploader__upload-btn__input {
			display: none;
		}

		.product-img-uploader__img-box {
			position: relative;
			height: 200px;
			margin-top: 14px;
		}

		.product-img-uploader__img {
			float: left;
			display: block;
			width: 120px;
			height: auto;
		}

		.btn-originalimage {
			bottom: 0;
			left: 172px;
		}

		.product-img-uploader__img-info {
			overflow: hidden;
			height: 100%;
			padding: 14px;
			font-weight: 700;
		}

		.product-img-uploader__img-info__text {
			line-height: 20px;
		}
	}
</style>
